(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["layout-portal-header"] && !Shopify.designMode) return;
  try {
    (function() {
    function updateAuthLink() {
      var isPortal = window.location.pathname.includes('/pages/portal');
      var btn = document.getElementById(isPortal ? 'portal-header-login-button' : 'header-login-button');
      if (!btn) return;
      var link = btn.querySelector('a');
      if (!link) return;
  
      fetch('/account.js', { credentials: 'include', redirect: 'manual' })
        .then(function(r) {
          var loggedIn = r.type !== 'opaqueredirect' && r.ok;
          if (isPortal) {
            if (loggedIn) {
              link.innerHTML = 'Log&nbsp;Out';
              link.setAttribute('aria-label', 'Log Out');
              link.setAttribute('href', '/account/logout');
            } else {
              link.innerHTML = 'Log&nbsp;In';
              link.setAttribute('aria-label', 'Log In');
              link.setAttribute('href', '/account');
            }
          } else {
            if (loggedIn) {
              link.innerHTML = 'Dashboard';
              link.setAttribute('aria-label', 'Dashboard');
            } else {
              link.innerHTML = 'Log&nbsp;In';
              link.setAttribute('aria-label', 'Log In');
            }
          }
        })
        .catch(function() {});
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAuthLink);
    } else {
      updateAuthLink();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
